export enum ConnectorTypeEnum {
  FACEBOOK = 'facebook',
  SHOPIFY = 'shopify',
}
